<template>
  <div class="">
    <form v-on:submit.prevent="doReferFriend">
      <div class="form-group row">
        <label class="col-sm-5 col-form-label">First Name(s)*</label>
        <input
          type="text"
          name="name"
          id="friendName"
          v-model="friendDetails.name"
          v-validate="'required'"
          placeholder="John"
          class="col-sm-7 form-control"
        >

        <div class="invalid-feedback">{{errors.first('name')}}</div>

        <label class="col-sm-5 col-form-label">Email*</label>
        <input
          type="type"
          name="Email"
          id="friendEmail"
          v-model="friendDetails.email"
          v-validate="'required|email'"
          placeholder="example@email.com"
          class="col-sm-7 form-control"
        >
         <div class="invalid-feedback">{{errors.first('Email')}}</div>

         <label for="message" class="col-sm-5 col-form-label">Send a Message</label>
         <textarea
          name="message"
          id="message"
          v-model="friendDetails.message"
          class="col-sm-7 form-control"
          placeholder="Write a nice message for your friends!"
        ></textarea>

        <ButtonWithLoading
          class="mx-auto btn btn-primary"
          type="submit"
          text="Refer Friend"
          loadingText="Referring Friend"
          successText="Friend Referred"
          failureText="Error Referring Friend"
          :state="referFriendState"
        />
      </div>
    </form>
  </div>
</template>

<script>
import ButtonWithLoading from "@/components/buttonWithLoading";
import { postReferFriend } from "@/network/userRequests";
import { fetchUserDetails} from '@/network/userRequests';

export default {
  name: 'ReferFriend',
  components: {
    ButtonWithLoading
  },
  data(){
    return{
      friendDetails: {},
      referFriendState: null,
      userID: "",
    }
  },
  created() {
    fetchUserDetails(userDetails => this.userID = userDetails.member_details.account_id_fk );
  },
  methods:{
    doReferFriend(){
      this.$validator.validateAll().then(valid => {
        if (!valid) return;

        this.referFriendState = "loading";
        const referName = this.friendDetails.name;
        const referEmail = this.friendDetails.email;
        const referMessage = this.friendDetails.message;
        postReferFriend(
          { name: referName, email: referEmail, message: referMessage },
          () => {
            //success referring friend
            this.$gtm.trackEvent({
              event: "referPotentialMember",
              value: this.userID
            })
            this.referFriendState = "success";
            this.errors.clear();
            this.$validator.reset();
          },
          () => {
            //failure referring friend
            this.referFriendState = "failure";
            this.message = "Error Referring Friend";
          }
        );
        //reset button state after submission of form
        setTimeout(() => {
          this.referFriendState = null;
          this.friendDetails.email ="";
          this.friendDetails.name="";
          this.friendDetails.message="";
        }, 4500);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  textarea{
    margin-bottom: 10px;
  }
</style>
